export const globalGtm = {
  execed: "GTM-WLWLFTM",
  degree: "GTM-K44KMG4",
};
